export enum ReportType {
    BulkValuations,
}

export const ReportTypeArray = [ReportType.BulkValuations];

export const ReportTypeMap = {
    [ReportType.BulkValuations]: "Bulk Valuations",
};

export const DefaultMaximum = 999999;
